import * as React from 'react'
import { Link as LinkComponent } from 'widgets-for-react'
import { Link } from './types.gen'
import { ButtonProps } from './widgets/featuredContentBlock.gen'
import { LinkProps } from './widgets/linkBlock.gen'

export function getClassName<style>(options: { style?: style }, className: keyof style, notset: string = ''): string {
  return String(options && options.style && options.style[className] ? options.style[className] : notset)
}

export function link(
  link: Link,
  style: { classname: string },
  inner: JSX.Element | string,
  onClick?: () => void
): JSX.Element {
  if (
    !link.url.startsWith('/') &&
    !link.is_link_external &&
    !link.url.startsWith('http:') &&
    !link.url.startsWith('www.') &&
    !link.url.startsWith('https:')
  ) {
    link.url = '/' + link.url
  }
  return link.is_link_external || link.target === '_blank' ? (
    <a
      className={style.classname}
      target={link.target}
      rel={link.target === '_blank' ? 'noopener' : null}
      href={link.url}
      onClick={onClick ? onClick : null}
    >
      {inner}
    </a>
  ) : (
    <LinkComponent className={style.classname} to={link.url} onClick={onClick ? onClick : null}>
      {inner}
    </LinkComponent>
  )
}

//  This function matches the url of a DrupalLink against a regex that checks if the url that we want to
//  navigat to is on the same host we are curently at, or is only a path so we can use the <Link> component
//  otherwhise, if it isnt a url on our own hostname it returns true and is external.

export const isLinkExternal = (link: string): boolean => {
  let currentUrl = window.location.host
  let pattern = RegExp(`(https?:\/\/(!?${currentUrl}/.*)|^\/.*)`, 'gm')
  return !pattern.test(link)
}

// Strip a Drupal link of its domain information so we only have the path left

const stripUrlToPath = (link: { title: string; url: string }): string => {
  let a = document.createElement('a')
  a.href = link.url
  return a.pathname
}

// Create a link from an acf link that checks if it is external, and rewrites the url if needed

export const buttonWrapper = (link: { title: string; url: string }): ButtonProps => ({
  kind: 'link',
  is_link_external: isLinkExternal(link.url),
  target: isLinkExternal(link.url) ? '_blank' : '_self',
  title: link.title,
  url: isLinkExternal(link.url) ? link.url : stripUrlToPath(link)
})

export const linkWrapper = (link: { title: string; url: string }): Link => ({
  kind: 'link',
  is_link_external: isLinkExternal(link.url),
  target: isLinkExternal(link.url) ? '_blank' : '_self',
  title: link.title,
  url: isLinkExternal(link.url) ? link.url : stripUrlToPath(link)
})

export const parseLinkProps = (link: { title: string; url: string }, description: string, key: number): LinkProps => ({
  key: key.toString(),
  title: link.title,
  text: description ? description : '',
  is_link_external: isLinkExternal(link.url),
  target: isLinkExternal(link.url) ? '_blank' : '_self',
  url: isLinkExternal(link.url) ? link.url : stripUrlToPath(link)
})
